import { Box,  Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import React from 'react'

export default function ConnectWallet() {
  return (
    <Stack border="1px solid #c5c5c5" borderRadius="10px" px={8} py={6}>
        <Heading
        fontWeight={"semibold"}
        fontSize={{ base: "21px", md: "26px" }}
        pb={5}
        >
            Connect Wallet 
        </Heading>
        <SimpleGrid columns={{md:2}} gap={8}>
            <Stack alignItems="center" bg="#c5c5c56E" p={5} borderRadius={10} cursor="pointer">
                <Image src="/images/freelancer/buy-connect/metamask.png" m="auto" />
            </Stack>
            <Box bg="#c5c5c56E" p={5} borderRadius={10} cursor="pointer">
                <Image src="/images/freelancer/buy-connect/trust.png"  />
            </Box>
            <Box bg="#c5c5c56E" p={5} borderRadius={10} cursor="pointer">
                <Image src="/images/freelancer/buy-connect/wallet.png"  />
            </Box>
            <Stack justifyContent="center" alignItems="center" color="brand.400" cursor="pointer">
                <Text fontSize="20px" fontWeight="semibold" textDecor={"underline"}>
                    View More
                </Text>
            </Stack>
        </SimpleGrid>
    </Stack>
  )
}
